export default {
  props: {
    prodotto: Object,
    listino: String,
  },
  data() {
    return {}
  },
  computed: {
    prod() {
      return this.$store.getters.get_prodotto_raw_by_id(
        this.prodotto.id_prodotto
      );
    },
    nome() {
      return this.prod.nome.split(" in ");
    },
    prodotto_raw() {
      return this.$store.getters.get_prodotto_by_id(this.prodotto.id_prodotto);
    },
    avatar_img() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/avatar_img/" +
        this.prodotto.id_prodotto
      );
    },
    prezzo_prodotto() {
      if (this.prodotto.prezzo_contato) {
        return this.prodotto.prezzo_contato;
      }
      switch (this.listino) {
        case "1":
          return this.prodotto_raw.prezzo1;
        case "2":
          return this.prodotto_raw.prezzo2;
        case "3":
          return this.prodotto_raw.prezzo3;
      }
      return 0;
    },
    tot_conteggiato() {
      return this.prodotto.qta * this.prezzo_prodotto;
    },
  },
};
